<template>
  <div class="contacts">
    <h1 class="contacts-head">Контакты</h1>
    <section class="contacts-phones">
      <div class="contacts-phones__support">
        <p class="contacts-phones__support-text">Поддержка клиентов</p>
        <a href="mailto:orders@biletdv.ru" class="contacts-phones__support-mail"
          >orders@biletdv.ru</a
        >
      </div>
      <hr class="contacts-phones__line" />
      <div class="contacts-phones__moscow">
        <p class="contacts-phones__moscow-text">Для звонков из Москвы</p>
        <a href="tel:+74956655313" class="contacts-phones__moscow-number"
          >+7 (495) 665-53-13</a
        >
      </div>
      <hr class="contacts-phones__line" />
      <div class="contacts-phones__khab">
        <p class="contacts-phones__khab-text">Для звонков из Хабаровска</p>
        <a href="tel:+74212300100" class="contacts-phones__khab-number"
          >+7 (4212) 30-01-00</a
        >
      </div>
      <hr class="contacts-phones__line" />
      <div class="contacts-phones__skype">
        <p class="contacts-phones__skype-text">Для звонков по всему миру</p>
        <a href="skype:biletdv" class="contacts-phones__skype-number"
          ><div class="contacts-phones__skype-number__svg">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.787 6.06225C11.787 2.946 9.225 0.41925 6.06375 0.41925C5.73075 0.41925 5.40375 0.44775 5.085 0.50175C4.5735 0.1845 3.96825 0 3.3195 0C1.48575 0 0 1.46475 0 3.273C0 3.87675 0.1665 4.4415 0.456 4.92825C0.38025 5.29425 0.33975 5.6745 0.33975 6.06225C0.33975 9.17925 2.9025 11.706 6.063 11.706C6.4215 11.706 6.771 11.673 7.1115 11.6115C7.5795 11.859 8.11275 12 8.68125 12C10.5142 12 12 10.5345 12 8.72775C12 8.20575 11.8755 7.71225 11.655 7.27425C11.742 6.88275 11.787 6.4785 11.787 6.06225Z"
                fill="#03A9F4"
              />
              <path
                d="M8.99925 8.75928C8.7345 9.12903 8.34375 9.42153 7.836 9.62853C7.33425 9.83403 6.7335 9.93978 6.048 9.93978C5.226 9.93978 4.53675 9.79728 3.99825 9.51528C3.6135 9.31053 3.297 9.03378 3.05625 8.69028C2.8125 8.34528 2.69025 8.00253 2.69025 7.67028C2.69025 7.46478 2.7705 7.28478 2.92875 7.13853C3.0855 6.99228 3.2865 6.91953 3.5265 6.91953C3.723 6.91953 3.8925 6.97728 4.0305 7.09203C4.16175 7.20303 4.275 7.36653 4.36575 7.57578C4.467 7.80528 4.57725 7.99878 4.6935 8.14953C4.80675 8.29728 4.968 8.42028 5.17425 8.51703C5.382 8.61303 5.66175 8.66328 6.00525 8.66328C6.4785 8.66328 6.867 8.56278 7.158 8.36703C7.44375 8.17578 7.58175 7.94478 7.58175 7.66278C7.58175 7.44078 7.509 7.26528 7.36125 7.12803C7.20525 6.98403 6.99975 6.87228 6.75075 6.79503C6.4905 6.71553 6.13725 6.62853 5.70075 6.53853C5.106 6.41328 4.60125 6.26553 4.20075 6.09603C3.7905 5.92353 3.459 5.68503 3.2175 5.38728C2.9715 5.08278 2.847 4.70253 2.847 4.25553C2.847 3.82953 2.9775 3.44553 3.2355 3.11403C3.49125 2.78478 3.86475 2.52753 4.347 2.35278C4.82175 2.17953 5.3865 2.09253 6.02625 2.09253C6.537 2.09253 6.98625 2.15103 7.362 2.26653C7.73925 2.38203 8.05725 2.53803 8.307 2.73078C8.559 2.92578 8.7465 3.13203 8.8635 3.34803C8.982 3.56553 9.04275 3.78228 9.04275 3.99153C9.04275 4.19328 8.964 4.37703 8.808 4.53603C8.6505 4.69653 8.4525 4.77753 8.22 4.77753C8.0085 4.77753 7.842 4.72578 7.72725 4.62603C7.62 4.53228 7.50825 4.38603 7.38525 4.17753C7.24275 3.91053 7.0695 3.69978 6.8715 3.55053C6.67875 3.40578 6.35775 3.33378 5.91525 3.33378C5.50575 3.33378 5.17125 3.41478 4.92375 3.57528C4.68525 3.72903 4.569 3.90603 4.569 4.11603C4.569 4.24428 4.6065 4.35153 4.68375 4.44378C4.76475 4.54278 4.8795 4.62753 5.025 4.69953C5.175 4.77378 5.33025 4.83378 5.4855 4.87578C5.6445 4.91928 5.91075 4.98453 6.2775 5.06778C6.741 5.16528 7.16625 5.27553 7.54275 5.39478C7.9245 5.51403 8.253 5.66178 8.523 5.83503C8.79675 6.01128 9.0135 6.23628 9.168 6.50628C9.3225 6.77853 9.4005 7.11228 9.4005 7.50078C9.39975 7.96503 9.26475 8.38878 8.99925 8.75928Z"
                fill="#FAFAFA"
              />
            </svg>
          </div>
          <p class="contacts-phones__skype-number__text">Skype</p></a
        >
      </div>
    </section>
    <section class="contacts-mails">
      <div class="contacts-mails__claim">
        <p class="contacts-mails__claim-text">Для жалоб и предложений</p>
        <a href="mailto:claim@biletdv.ru" class="contacts-mails__claim-mail"
          >claim@biletdv.ru</a
        >
      </div>
    </section>
  </div>
</template>

<script>
import { Vue } from "vue-class-component";

export default class Contacts extends Vue {}
</script>

<style lang="scss">
@media screen and (max-width: 1024px) {
  .contacts-head {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    margin: 2px 0 0 20px;
  }

  .contacts-phones {
    overflow: hidden;
    margin: 18px 0 0 0;
    background: #ffffff;
    border-radius: 5px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  }

  .contacts-phones__moscow {
    margin: 13px 0 0 20px;
  }
  .contacts-phones__moscow-text {
    display: block;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    color: #939090;
  }

  .contacts-phones__moscow-number {
    display: block;
    margin-top: 10px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    text-decoration-line: underline;
    -webkit-tap-highlight-color: transparent;
    color: #1867c0;
  }

  .contacts-phones__line {
    margin: auto;
    margin-top: 15px;
    border: none;
    background-color: #939090;
    height: 0.5px;
    width: 92%;
  }

  .contacts-phones__khab {
    margin: 13px 0 0 20px;
  }

  .contacts-phones__khab-text {
    display: block;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    color: #939090;
  }

  .contacts-phones__khab-number {
    display: block;
    margin-top: 10px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    text-decoration-line: underline;
    -webkit-tap-highlight-color: transparent;
    color: #1867c0;
  }

  .contacts-phones__skype {
    margin: 13px 0 16px 20px;
  }

  .contacts-phones__skype-text {
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    color: #939090;
  }

  .contacts-phones__skype-number {
    display: flex;
    margin-top: 10px;
    -webkit-tap-highlight-color: transparent;
    align-items: center;
  }

  .contacts-phones__skype-number__text {
    display: block;
    margin-left: 7px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    text-decoration-line: underline;
    color: #1867c0;
  }

  .contacts-mails {
    overflow: hidden;
    margin: 22px 0 0 0;
    background: #ffffff;
    border-radius: 5px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  }

  .contacts-mails__claim {
    margin: 13px 0 15px 20px;
  }

  .contacts-mails__claim-text {
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    color: #939090;
  }

  .contacts-mails__claim-mail {
    display: block;
    margin-top: 10px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    text-decoration-line: underline;
    -webkit-tap-highlight-color: transparent;
    color: #1867c0;
  }

  .contacts-mails__line {
    margin: auto;
    margin-top: 15px;
    border: none;
    background-color: #939090;
    height: 0.5px;
    width: 92%;
  }

  .contacts-phones__support {
    margin: 13px 0 0 20px;
  }

  .contacts-phones__support-text {
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    color: #939090;
  }

  .contacts-phones__support-mail {
    display: block;
    margin-top: 10px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    text-decoration-line: underline;
    -webkit-tap-highlight-color: transparent;
    color: #1867c0;
  }

  .contacts-mails__req {
    margin: 13px 0 20px 20px;
  }

  .contacts-mails__req-text {
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    color: #939090;
  }

  .contacts-mails__req-link {
    display: block;
    margin-top: 10px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    text-decoration-line: underline;
    -webkit-tap-highlight-color: transparent;
    color: #1867c0;
  }
}

@media screen and (min-width: 1025px) {
  .contacts-head {
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    margin: 0 0 0 20px;
  }

  .contacts-phones {
    overflow: hidden;
    margin: 18px 0 0 0;
    background: #ffffff;
    border-radius: 5px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  }

  .contacts-phones__moscow {
    margin: 13px 0 0 20px;
  }
  .contacts-phones__moscow-text {
    display: block;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #939090;
  }

  .contacts-phones__moscow-number {
    display: block;
    margin-top: 10px;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    text-decoration-line: underline;
    -webkit-tap-highlight-color: transparent;
    color: #1867c0;
  }

  .contacts-phones__moscow-number:hover {
    text-decoration: none;
  }

  .contacts-phones__line {
    margin: auto;
    margin-top: 15px;
    border: none;
    background-color: #939090;
    height: 0.5px;
    width: 92%;
  }

  .contacts-phones__khab {
    margin: 13px 0 0 20px;
  }

  .contacts-phones__khab-text {
    display: block;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #939090;
  }

  .contacts-phones__khab-number {
    display: block;
    margin-top: 10px;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    text-decoration-line: underline;
    -webkit-tap-highlight-color: transparent;
    color: #1867c0;
  }

  .contacts-phones__khab-number:hover {
    text-decoration: none;
  }

  .contacts-phones__skype {
    margin: 13px 0 16px 20px;
  }

  .contacts-phones__skype-text {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;

    color: #939090;
  }

  .contacts-phones__skype-number {
    display: flex;
    margin-top: 10px;
    align-items: center;
    -webkit-tap-highlight-color: transparent;
    text-decoration: none;
  }

  .contacts-phones__skype-number__text {
    display: block;
    margin-left: 7px;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    text-decoration-line: underline;
    color: #1867c0;
  }

  .contacts-phones__skype-number__text:hover {
    text-decoration: none;
  }

  .contacts-mails {
    overflow: hidden;
    margin: 22px 0 0 0;
    background: #ffffff;
    border-radius: 5px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  }

  .contacts-mails__claim {
    margin: 13px 0 15px 20px;
  }

  .contacts-mails__claim-text {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #939090;
  }

  .contacts-mails__claim-mail {
    display: block;
    margin-top: 10px;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    text-decoration-line: underline;
    -webkit-tap-highlight-color: transparent;
    color: #1867c0;
  }

  .contacts-mails__claim-mail:hover {
    text-decoration: none;
  }

  .contacts-mails__line {
    margin: auto;
    margin-top: 15px;
    border: none;
    background-color: #939090;
    height: 0.5px;
    width: 92%;
  }

  .contacts-phones__support {
    margin: 13px 0 0 20px;
  }

  .contacts-phones__support-text {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #939090;
  }

  .contacts-phones__support-mail {
    display: block;
    margin-top: 10px;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    text-decoration-line: underline;
    -webkit-tap-highlight-color: transparent;
    color: #1867c0;
  }

  .contacts-phones__support-mail:hover {
    text-decoration: none;
  }

  .contacts-mails__req {
    margin: 13px 0 20px 20px;
  }

  .contacts-mails__req-text {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #939090;
  }

  .contacts-mails__req-link {
    display: block;
    margin-top: 10px;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    text-decoration-line: underline;
    -webkit-tap-highlight-color: transparent;
    color: #1867c0;
  }

  .contacts-mails__req-link:hover {
    text-decoration: none;
  }
}
</style>
